import styled from 'styled-components'

export const Container = styled.div<any>`
  padding: 0 25px 1px;
  ${props => props.isWorking && `
    cursor: wait;
  `}

  button {
    display: block;
    font-size: 22px;
    width: 100%;
    margin: 0;
    ${props => props.isWorking && `
      pointer-events: none;
    `}
  }
`
